import { Heading } from '@chakra-ui/layout';
import React from 'react';
import Layout from '../../components/Layout';
import classes from './styles.module.scss';
import { BRAND_NAME } from '../../constants';

export default function TermsConditions() {
  return (
    <Layout>
      <div className={classes.TermsConditions}>
        <Heading as="h1">Terms and Condition</Heading>
        <Heading as="h4" size="md">
          Introduction
        </Heading>
        <p>
          These Terms and Conditions (the "Terms") are a binding contract
          between You ("User", "End User", "You", "Customer") and GreedyGame
          Media Private Limited ("Company, "GreedyGame", "we", "{BRAND_NAME}",
          "our" and "us"). You must agree to and accept all of the Terms or you
          don't have the right to use the Services. Your use of the Services in
          any way implies that you agree to all of these Terms and these Terms
          will remain in effect during your usage of the services.
        </p>
        <p>
          When you register on {BRAND_NAME} and start using it, these terms will
          automatically apply to you. You should make sure therefore that you
          read them carefully before using the product/service. You are not
          allowed to copy or modify the product/service any part of the
          product/service or our trademarks in any way. You are not allowed to
          try and attempt to extract the source code of the product/service and
          you also shouldn't try to translate the product/service into other
          languages or make derivative versions. The product/service itself and
          all the trademarks, copyright, database rights and other intellectual
          property rights related to it belong to GreedyGame Media Pvt. Ltd.,
          the owner of the product/service - {BRAND_NAME}. These terms are
          subject to change, so you are advised to keep checking them.
        </p>
        <p>
          These terms constitute an electronic record as per the provisions of
          the Information Technology Act, 2000 and the Information Technology
          (Intermediaries guidelines) Rules, 2011 thereunder as amended from
          time to time. {BRAND_NAME} is not for use by any minors (defined as
          those who are not at least 18 years of age) and you must not use or
          access
          {BRAND_NAME} if you a minor. We reserve the sole right to make changes
          to the product/service at any time and for any reason in the future.
        </p>
        <Heading as="h4" size="md">
          Rewards
        </Heading>
        <p>
          For every tasks completed, users are eligible to earn rewards (“
          Chillars”). User’s Chillars earned for tasks completed shall be based
          solely on the number and quality of acceptable reports received by
          {BRAND_NAME} from its Clients (“Advertisers”). {BRAND_NAME} is not
          liable for rewards lost or not credited to the user's wallet due to
          internet connectivity issues, bugs in the {BRAND_NAME} system,
          incorrect UPI ID provided by user or Inactive wallet or any other
          factors. {BRAND_NAME} is not liable to make any payment to the user if
          the pertinent payment from Advertiser is not received by {BRAND_NAME}.
        </p>
        <p>
          Chillars credited to the user in the {BRAND_NAME} wallet &amp; cash
          converted from Chillars will expire from the user's wallet if not
          utilized within <strong>60 days</strong> of accrual. In other words, if a user doesn't
          redeem coins/ cash earned from coins within 60 days of earning them,
          they will then be expunged from user's wallet.
        </p>
        <p>
          Mobile recharges or other rewards redeemed by users are completed
          using a third-party application. {BRAND_NAME} is not responsible for
          failed or unsuccessful recharge transactions and repayment of the
          same.
        </p>
        <Heading as="h4" size="md">
          Limitation Of Authority
        </Heading>
        <p>
          User shall have no authority to bind, obligate or commit {BRAND_NAME}{' '}
          in any manner, including by any promise or representation, whether
          oral or written, unless specifically authorized by {BRAND_NAME} in
          writing.
        </p>
        <Heading as="h4" size="md">
          Disputes
        </Heading>
        <p>
          In the event any dispute, arbitration or litigation arises out of in
          connection with or as a result of any act performed by User according
          to this agreement or failure to perform as the case may be, User shall
          cooperate fully with {BRAND_NAME} to resolve the same. User agrees to
          indemnify and hold {BRAND_NAME} harmless of and from any and all
          claims, demands, suits and liabilities including costs and attorney's
          fees to which {BRAND_NAME} may be subjected because of or in
          connection with any proceeding arising out of the conduct or omissions
          of User. It is the policy of {BRAND_NAME} to avoid litigation whenever
          possible but the decision of whether or not to enter into or maintain
          litigation shall be the decision of {BRAND_NAME} alone. This
          obligation shall survive the termination or expiration of this
          Agreement.
        </p>
        <Heading as="h4" size="md">
          Training
        </Heading>
        <p>
          {BRAND_NAME} will provide the User with instructions and forms
          designed to assist the user in completing a task for {BRAND_NAME} all
          of which shall remain {BRAND_NAME}'s sole property.
        </p>
        <Heading as="h4" size="md">
          Non-Solicitation
        </Heading>
        <p>
          User will not on behalf of himself or any third party, employ or seek
          to employ any person employed by or engaged by {BRAND_NAME} and its
          team around the world or otherwise directly or indirectly induce such
          persons to leave their employment.
        </p>
        <Heading as="h4" size="md">
          Confidential Information
        </Heading>
        <p>
          While User is using {BRAND_NAME} and thereafter, User will hold in
          strictest confidence, maintain as confidential and not disclose to any
          third party the following: (i) Any and all information concerning
          {BRAND_NAME}'s present or former customers including their names and
          identities, locations and addresses, their employees and
          representatives, business practices as well as the information sought
          to be gathered and actually gathered in connection with the services
          provided by {BRAND_NAME} to its customers; (ii) Any and all
          information concerning {BRAND_NAME}'s employees and representatives as
          well as any information designated orally or in writing as
          confidential by {BRAND_NAME} App regarding {BRAND_NAME}'s sales
          methods, plans and records, {BRAND_NAME} App's collections on behalf
          of its customers, all written communications, training and marketing
          materials and all other like documents not disseminated to the general
          public including computer programs and printouts as well as any other
          confidential information regarded by {BRAND_NAME} as a trade secret or
          otherwise protected from disclosure under applicable law. The user
          may, in accordance with the foregoing, use such information solely as
          necessary in the User's use of {BRAND_NAME}.
        </p>
        <Heading as="h4" size="md">
          Termination and Limitation of Liability
        </Heading>
        <p>
          Either party may at any time terminate this Agreement for any reason
          or for no reason at all. However each shall continue to comply with
          any and all obligations of this Agreement that are intended to survive
          its termination or expiration. Once the user terminates this agreement
          between the user and {BRAND_NAME}, the user will not be allowed to use
          the services of {BRAND_NAME}. Continue use of {BRAND_NAME} means that
          the user has accepted these terms and the User shall be bound by these
          terms.
        </p>
        <p>
          In case of any fraudulent activities detected from your end to
          disrupt, manipulate or hinder the right usage of {BRAND_NAME} and its
          services, the company holds the right to terminate your access to the
          product without notice and initiate prosecution proceeding against you
          along with recovery of such amount and damages. In no event shall the
          Company nor any of its officers, directors, affiliates, employees,
          agents, and consultants be liable to you for anything arising out of
          or in any way connected with your use of {BRAND_NAME} whether such
          liability is under contract, tort or otherwise and Company including
          its officers, directors, and employees shall not be liable for any
          indirect, consequential or special liability arising out of or in any
          way related to your use of {BRAND_NAME}.
        </p>
        <p>
          We cannot control and have no duty to take any action regarding how
          you may interpret and use the Content or what actions you may take as
          a result of having been exposed to the Content and you hereby release
          us from all liability for you having acquired or not acquired Content
          through the Services.
        </p>
        <p>
          User understands that in the event of termination or expiration, User
          will receive the balance recharge due to User for tasks that{' '}
          {BRAND_NAME}
          has deemed acceptable. {BRAND_NAME} and User shall deal with each
          other fairly and in good faith relative to this Agreement. User
          further understands that if User has participated in any incentive
          promotion pursuant to which User may be entitled to a bonus, trip, or
          any kind of award/ rewards User will not be entitled to the same if it
          was not actually received prior to the date of termination.{' '}
          {BRAND_NAME} may terminate User accounts without prior notice if any
          suspicious activity is found which comes in the way of the natural or
          intended functioning of {BRAND_NAME}. {BRAND_NAME} may terminate
          user(s) account(s) if the user is found to be indulging in promoting
          their {BRAND_NAME}
          referral links or any other codes on Facebook, Google Play, or any
          other public properties along with misleading or spammy communication
          of any nature. Termination of user accounts will be at the sole
          discretion of {BRAND_NAME}.
        </p>
        <Heading as="h4" size="md">
          Breach Of Agreement
        </Heading>
        <p>
          User understands and agrees that any breach or threatened breach by
          User of the non-competition and non-disclosure provisions or any other
          provision contained in this Agreement will cause {BRAND_NAME}{' '}
          substantial, irreparable harm which is difficult to measure and that
          {BRAND_NAME} therefore may obtain an injunction against such conduct
          and User consents thereto. This right is in addition to any other
          rights
          {BRAND_NAME} may have against User for breach of this Agreement.
          Therefore whenever {BRAND_NAME} may apply for a restraining order or
          injunction against User for breaching or threatening to breach this
          Agreement as described above, User waives any notice to which User may
          be entitled and consents to such restraining order or injunction. If
          {BRAND_NAME} proceeds against User in the State court of Delhi or the
          Indian High Courts/ Supreme Court situated in or closest to said area
          of Delhi on any cause of action arising out of this Agreement, User
          agrees that such court may exercise personal jurisdiction over User.
          In the event of any breach of this Agreement by the User, the User
          agrees to pay {BRAND_NAME} all losses and damages sustained as a
          result thereof as well as court costs, attorney fees, and related
          expenses.
        </p>
        <Heading as="h4" size="md">
          Miscellaneous
        </Heading>
        <p>
          {BRAND_NAME} services are available only to and can only be used by an
          individual who can form legally binding contracts as per the
          prevailing laws in India. The term individual shall only include a
          living person and does not include all other legal creations. The
          services are not available to minors under the age of 18 or to any
          users suspended or removed from accessing {BRAND_NAME} for any reason.
          Each notice to either {BRAND_NAME} or User required hereunder shall be
          in writing and emailed to the addresses provided by the parties unless
          and until any such address is changed in writing. {BRAND_NAME} and
          User shall exercise their best efforts to communicate to the other any
          such change in address. Such notices shall be deemed given when mailed
          by certified mail, return receipt requested. Any written notice may be
          personally delivered but personally delivered notices shall be deemed
          given on the date of actual receipt.
        </p>
        <p>
          This Agreement contains the entire understanding and agreement between
          the parties and supersedes all prior written agreements,
          understandings and negotiations both written and oral between the
          Parties. {BRAND_NAME} reserves the right to make changes to the Site
          related policies and agreements, the terms of services and the Privacy
          Policy at any time without prior notice to the user. {BRAND_NAME} may
          assign this Agreement to any successor to all or part of its business
          or any parent, subsidiary or an affiliated company. User may not
          assign these Terms, or any part thereof without {BRAND_NAME}'s written
          consent.
        </p>
        <p>
          These terms contemplate the creation of a relationship of independent
          contractor by and between {BRAND_NAME} and end users; with User as
          Contractor and {BRAND_NAME} as Contractee. Nothing herein is intended
          to create nor should be construed as creating the relationship of
          employer and employee. These terms shall be governed by and construed
          in accordance with the laws of India without regard to conflicts of
          laws principles. The Court of Delhi, India shall have the exclusive
          jurisdiction pertaining to any matter arising out of this agreement.
          If any provision of this Agreement is declared invalid under such
          laws, the validity of the other provisions shall not be affected
          thereby and that part shall remain enforced. Furthermore, the User
          agrees to abide by all local, state, and national laws where
          applicable while serving in the capacity of Independent Contractor/
          User to {BRAND_NAME}. It shall be the user's responsibility to read
          and understand the terms and conditions of the agreement and privacy
          policy updated from time to time and the {BRAND_NAME} shall not be
          responsible for any failure therein on the part of the user. No
          agency, partnership, joint venture, or employment is created as a
          result of these Terms and you do not have any authority of any kind to
          bind the Company in any respect whatsoever.
        </p>
        <Heading as="h4" size="md">
          Payment terms for {BRAND_NAME} Platform
        </Heading>
        <p>
          <ul>
            <li>All earnings can be withdrawn to bank accounts only.</li>
            <li>
              Name on the bank account should be same as the name on PAN card
              associated with your {BRAND_NAME} account.
            </li>
            <li>
              A TDS of 5% will be deducted on every amount earned by the user
            </li>
            <li>
              This TDS is deposited as per government compliance and a TDS
              certificate will be shared with users every quarter. This can be
              downloaded from the app.
            </li>
            <li>
              For contests and giveaways, {BRAND_NAME} reserves the right to
              charge a Platform Fee which would be specified and notified by{' '}
              {BRAND_NAME}.
            </li>
            <li>
              The User acknowledges that subject to time taken for bank
              transfers and such other external dependencies that {BRAND_NAME}{' '}
              has on third parties, any transactions on {BRAND_NAME} Platform
              may take up to 7 business days to be processed. In rare
              circumstances it may also take longer.
            </li>
            <li>
              At the time of the transaction, Users may also be required to take
              note of certain additional terms and conditions and such
              additional terms and conditions shall also govern the transaction.
              To the extent that the additional terms and conditions contain any
              clause that is conflicting with the present terms and conditions,
              the additional terms and conditions shall prevail.
            </li>
          </ul>
        </p>
        <Heading as="h4" size="md">
          Campaigns
        </Heading>
        <p>
          In respect of any campaigns running, to run or to be executed in the
          future or not to be executed on the {BRAND_NAME} platform is the sole
          and absolute discretion of {BRAND_NAME} to run or not run a campaign
          or use complete/ partial information from the campaign as provided to
          {BRAND_NAME} App.
        </p>
        <p>
          If you have any questions or suggestions about these Terms and
          Conditions, do not hesitate to reach out to us at:- <br />
          <strong>
            GreedyGame Media Private Limited, No.04, 4th Floor, Zed Pentagon,
            Hosur Main Road, Bommanahalli, Bengaluru 560 068
          </strong>
        </p>
      </div>
    </Layout>
  );
}
